export default __webpack_public_path__ + "static/media/facebook_icon.eee1de42.svg";